import classNames from 'classnames';
import styles from './index.module.less';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';
import { CreditsAlertProps, LabelAlertType, LinkAlertType } from './interface';
import { creditst_fill } from '@shared/assets/svg/base';

export function BaseCreditsAlert(props: CreditsAlertProps) {
	const { message, className, style } = props;

	return (
		<div className={classNames(styles.credits_alert, className)} style={style}>
			<NewBaseIcon icon={creditst_fill} size={20} className={styles.credits_icon} />
			<div className={styles.credits_alert_message}>{message}</div>
			{(props as LabelAlertType)?.label && (
				<div className={styles.credits_alert_label}>
					<span>{(props as LabelAlertType).label.num}&nbsp;</span>
					{(props as LabelAlertType).label.text}
				</div>
			)}
			{(props as LinkAlertType)?.link && (
				<div className={styles.credits_alert_link}>{(props as LinkAlertType).link.text}</div>
			)}
		</div>
	);
}
